'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reportMap = require('./reportMap.html');

var _reportMap2 = _interopRequireDefault(_reportMap);

var _reportMap3 = require('./reportMap.controller');

var _reportMap4 = _interopRequireDefault(_reportMap3);

require('./reportMap.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportMapComponent = {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    template: _reportMap2.default,
    controller: _reportMap4.default,
    controllerAs: "vm"
};

exports.default = reportMapComponent;


// WEBPACK FOOTER //
// ./client/app/common/reportMap/reportMap.component.js